import { render, staticRenderFns } from "./GlobalStyleEditor.vue?vue&type=template&id=db2ae98c&scoped=true&"
import script from "./GlobalStyleEditor.vue?vue&type=script&lang=js&"
export * from "./GlobalStyleEditor.vue?vue&type=script&lang=js&"
import style0 from "./GlobalStyleEditor.vue?vue&type=style&index=0&id=db2ae98c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2ae98c",
  null
  
)

export default component.exports